module.exports = __webpack_public_path__ + "img/balloon.da2ca573.svg";